/* ============================================
   CART DRAWER — Slide-out panel UI (Shopify)
   ============================================ */

(function() {
  'use strict';

  window.Brume = window.Brume || {};

  var overlay, drawer, body, footer, totalAmount, shippingNote;
  var isLoading = false;
  var lastError = null;
  // Re-entrancy guard: a cap correction fires another cart change event.
  var enforcingCaps = false;

  // ── Inject HTML ─────────────────────────────

  function createDrawerHTML() {
    // Overlay
    overlay = document.createElement('div');
    overlay.className = 'cart-overlay';
    overlay.id = 'cartOverlay';

    // Drawer
    drawer = document.createElement('aside');
    drawer.className = 'cart-drawer';
    drawer.id = 'cartDrawer';
    drawer.innerHTML =
      '<div class="cart-drawer-header">' +
        '<h2 class="cart-drawer-title">Your Bag</h2>' +
        '<button class="cart-drawer-close" aria-label="Close bag">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<line x1="18" y1="6" x2="6" y2="18"></line>' +
            '<line x1="6" y1="6" x2="18" y2="18"></line>' +
          '</svg>' +
        '</button>' +
      '</div>' +
      '<div class="cart-drawer-body" id="cartDrawerBody"></div>' +
      '<div class="cart-shipping-note is-hidden" id="cartShippingNote">' +
        '<svg class="cart-shipping-icon" viewBox="0 0 30 30" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<path d="M15.48 12c-.13.004-.255.058-.347.152l-2.638 2.63-1.625-1.62c-.455-.474-1.19.258-.715.712l1.983 1.978c.197.197.517.197.715 0l2.995-2.987c.33-.32.087-.865-.367-.865zM.5 16h3c.277 0 .5.223.5.5s-.223.5-.5.5h-3c-.277 0-.5-.223-.5-.5s.223-.5.5-.5zm0-4h3c.277 0 .5.223.5.5s-.223.5-.5.5h-3c-.277 0-.5-.223-.5-.5s.223-.5.5-.5zm0-4h3c.277 0 .5.223.5.5s-.223.5-.5.5h-3C.223 9 0 8.777 0 8.5S.223 8 .5 8zm24 11c-1.375 0-2.5 1.125-2.5 2.5s1.125 2.5 2.5 2.5 2.5-1.125 2.5-2.5-1.125-2.5-2.5-2.5zm0 1c.834 0 1.5.666 1.5 1.5s-.666 1.5-1.5 1.5-1.5-.666-1.5-1.5.666-1.5 1.5-1.5zm-13-1C10.125 19 9 20.125 9 21.5s1.125 2.5 2.5 2.5 2.5-1.125 2.5-2.5-1.125-2.5-2.5-2.5zm0 1c.834 0 1.5.666 1.5 1.5s-.666 1.5-1.5 1.5-1.5-.666-1.5-1.5.666-1.5 1.5-1.5zm-5-14C5.678 6 5 6.678 5 7.5v11c0 .822.678 1.5 1.5 1.5h2c.676.01.676-1.01 0-1h-2c-.286 0-.5-.214-.5-.5v-11c0-.286.214-.5.5-.5h13c.286 0 .5.214.5.5V19h-5.5c-.66 0-.648 1.01 0 1h7c.66 0 .654-1 0-1H21v-9h4.227L29 15.896V18.5c0 .286-.214.5-.5.5h-1c-.654 0-.654 1 0 1h1c.822 0 1.5-.678 1.5-1.5v-2.75c0-.095-.027-.19-.078-.27l-4-6.25c-.092-.143-.25-.23-.422-.23H21V7.5c0-.822-.678-1.5-1.5-1.5z"/>' +
        '</svg>' +
        '<span>You\'ve got free shipping</span>' +
      '</div>' +
      '<div class="cart-drawer-footer" id="cartDrawerFooter">' +
        '<button class="cart-drawer-checkout">' +
          '<svg class="cart-checkout-lock" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>' +
            '<path d="M7 11V7a5 5 0 0 1 10 0v4"></path>' +
          '</svg>' +
          '<span>Pay Now</span>' +
          '<span class="cart-checkout-sep">&minus;</span>' +
          '<span class="cart-drawer-total-amount" id="cartTotalAmount">$0.00</span>' +
        '</button>' +
        '<div class="cart-trust">' +
          '<span class="cart-trust-item">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="5 12 10 17 19 7"></polyline></svg>' +
            '<span>14-day returns</span>' +
          '</span>' +
          '<span class="cart-trust-item">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="5 12 10 17 19 7"></polyline></svg>' +
            '<span>Free shipping worldwide</span>' +
          '</span>' +
        '</div>' +
        /* Accepted payment methods, from shop.enabled_payment_types via Liquid. */
        (function () {
          var icons = (window.BrumeConfig || {}).paymentIcons;
          return icons ? '<div class="cart-payment-icons" aria-label="Accepted payment methods">' + icons + '</div>' : '';
        })() +
      '</div>';

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    body = document.getElementById('cartDrawerBody');
    footer = document.getElementById('cartDrawerFooter');
    shippingNote = document.getElementById('cartShippingNote');
    totalAmount = document.getElementById('cartTotalAmount');
  }

  // ── Open / Close ────────────────────────────

  // While the mobile menu is open, `body.menu-open .nav` is deliberately
  // stacked above the modal layer, so the nav would cover the drawer. Close the
  // menu first — the two are never useful at once, and raising the drawer's
  // z-index instead would leave the menu open and invisible behind it.
  // Body scroll stays locked throughout: openDrawer sets it again below.
  function closeMobileMenu() {
    var nav = document.getElementById('nav');
    if (!nav || !nav.classList.contains('is-open')) return;
    nav.classList.remove('is-open');
    var toggle = document.getElementById('menuToggle');
    if (toggle) toggle.classList.remove('is-active');
    document.body.classList.remove('menu-open');
  }

  function openDrawer() {
    closeMobileMenu();
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.classList.add('cart-open');
    // The site header is hidden while the drawer is open (mobile); the drawer
    // only needs to clear the announcement banner. Record the banner's visible
    // bottom edge (0 when it's hidden, e.g. on desktop).
    var banner = document.querySelector('.top-banner');
    var bb = 0;
    if (banner && window.getComputedStyle(banner).display !== 'none') {
      bb = Math.max(0, Math.round(banner.getBoundingClientRect().bottom));
    }
    document.documentElement.style.setProperty('--cart-header-h', bb + 'px');
    // Shared lock (see brume-cart.js) — plain overflow:hidden is ignored by iOS.
    if (window.Brume && Brume.lockScroll) Brume.lockScroll();
    else document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.classList.remove('cart-open');
    var h = document.querySelector('.header');
    if (h) h.style.transform = '';
    if (window.Brume && Brume.unlockScroll) Brume.unlockScroll();
    else document.body.style.overflow = '';
  }

  // ── Helpers ─────────────────────────────────

  // Sentence-case each colour in a variant label, not just the first one, so a
  // two-device line reads "Silver + Pearl white" rather than "Silver + pearl
  // white". The span carries text-transform:none inline to beat the lowercase
  // rule on .cart-item-color in brume.css.
  function variantLabel(title) {
    return String(title || '').split('+').map(function (part) {
      part = part.trim();
      return part ? part.charAt(0).toUpperCase() + part.slice(1).toLowerCase() : part;
    }).join(' + ');
  }

  // Map a cart line item to a color key (silver / white) using its Color
  // option or variant title, so we can show the matching theme photo.
  function colorKeyFor(item) {
    var val = item.variant_title || '';
    if (item.options_with_values) {
      for (var i = 0; i < item.options_with_values.length; i++) {
        if (/color/i.test(item.options_with_values[i].name)) {
          val = item.options_with_values[i].value;
          break;
        }
      }
    }
    val = (val || '').toLowerCase();
    if (val.indexOf('white') !== -1) return 'white';
    return 'silver';
  }

  // A cart line is a subscription if it carries a selling plan.
  function planKeyFor(item) {
    if (item && (item.selling_plan_allocation || item.selling_plan)) return 'subscribe';
    return 'onetime';
  }

  // Is this cart line the refill cartridge rather than the filter?
  function isCartridge(item) {
    var s = ((item && (item.handle || '')) + ' ' + (item && item.product_title || '')).toLowerCase();
    return s.indexOf('cartridge') !== -1 || s.indexOf('refill') !== -1;
  }

  // Whole units when a price has no cents, matching money_without_trailing_zeros
  // filter used throughout the Liquid templates. Tested on the integer cent
  // value, not the divided float, so there is no rounding edge case; a genuine
  // $19.50 line still renders its cents.
  function money(cents) {
    cents = Math.round(cents || 0);
    var n = cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2);
    // shop.money_format, handed over in BrumeConfig, so the drawer follows the
    // store currency instead of hardcoding a symbol. Falls back to the bare
    // amount rather than inventing a currency the store may not use.
    var fmt = (window.BrumeConfig && BrumeConfig.moneyFormat) || '{{amount}}';
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
  }

  // No line-level cap. The subscription cartridge used to be capped at 1 because
  // the first delivery was free and someone ordered 15; at $19 the price itself
  // is the friction, so the cap was removed. Kept as the single place to
  // reintroduce one — `selectionIsMaxed()` in brume-buy.js and the drawer's
  // locked-row styling both key off a cap of 1, so they switch back on together.
  function maxQtyFor(item) {
    return 99;
  }

  // Pick the thumbnail for a line item. The colour map only describes the FILTER;
  // applying it to the cartridge showed a filter photo on refill lines, because
  // colorKeyFor() defaults to 'silver' for anything without "white" in it.
  function imageFor(item) {
    var cfg = window.BrumeConfig || {};
    if (isCartridge(item)) return cfg.cartridgeImage || (item && item.image) || '';
    var map = cfg.colorImages || {};
    return map[colorKeyFor(item)] || (item && item.image) || '';
  }

  // Lowercase the product name and render "brume" in the Days One brand font.
  /* Shorter names for the cart than the product carries in Shopify. The admin
     title is kept long for search ("brume bathroom faucet filter"); the cart
     reads better short. Checkout still shows the real title — Shopify owns that
     screen — so keep the two close enough that nobody thinks it changed. */
  var CART_DISPLAY_NAMES = {
    'brume-filter': 'brume faucet filter'
  };

  function displayTitle(item) {
    var h = item && item.handle;
    return (h && CART_DISPLAY_NAMES[h]) || (item && item.product_title) || '';
  }

  function brumeName(title) {
    return (title || '').toLowerCase().replace(/brume/g, '<span class="purchase-name-brume">brume</span>');
  }

  /* ── Optimistic quantity ─────────────────────
     A tap used to change nothing until Shopify answered /cart/change.js,
     measured at 580-840ms on the live store, so the number sat still and the
     tap felt broken. Now the drawer draws the tapped quantity at once and the
     request follows; pendingQty holds what the visitor has asked for, per
     line, until Shopify confirms it. Prices are scaled from the line's own
     unit price, so the line total and the bag total move with the number. */
  var pendingQty = {};
  var pendingTimers = {};
  var SYNC_DELAY = 300;   // group quick taps into a single request

  function displayQty(item) {
    return Object.prototype.hasOwnProperty.call(pendingQty, item.key) ? pendingQty[item.key] : item.quantity;
  }

  // A line's price for a given quantity, from its own per-unit price.
  function lineAt(item, field, qty) {
    if (!item.quantity) return item[field] || 0;
    return Math.round((item[field] || 0) / item.quantity * qty);
  }

  function queueSync(key) {
    if (pendingTimers[key]) clearTimeout(pendingTimers[key]);
    pendingTimers[key] = window.setTimeout(function () {
      delete pendingTimers[key];
      var qty = pendingQty[key];
      if (qty === undefined) return;
      Brume.Cart.updateQuantity(key, qty).then(function () {
        /* Drop the override only if no newer tap is waiting, otherwise this
           older answer would pull the number back under the visitor's finger. */
        if (!pendingTimers[key] && pendingQty[key] === qty) {
          delete pendingQty[key];
          renderCartItems();
        }
      }).catch(function () {
        delete pendingQty[key];
        renderCartItems();
      });
    }, SYNC_DELAY);
  }

  // What a line shows right now: its tapped quantity and the matching price.
  function lineDisplay(item) {
    var qty = displayQty(item);
    var finalLine = lineAt(item, 'final_line_price', qty);
    var originalLine = lineAt(item, 'original_line_price', qty);
    return {
      qty: qty,
      // A 0 line (the free first subscription cartridge) reads better as "Free".
      priceHTML: (finalLine === 0 ? 'Free' : money(finalLine)) +
        (originalLine > finalLine ? ' <span class="cart-item-price-was">' + money(originalLine) + '</span>' : '')
    };
  }

  function totalCentsNow(cart) {
    /* The server total, adjusted by whatever taps have not synced yet, so the
       figure stays exact (cart-level discounts included) when nothing pends. */
    var cents = Math.round(Brume.Cart.getCartTotal() * 100);
    for (var i = 0; i < cart.length; i++) {
      var dq = displayQty(cart[i]);
      if (dq !== cart[i].quantity) {
        cents += lineAt(cart[i], 'final_line_price', dq) - (cart[i].final_line_price || 0);
      }
    }
    return cents;
  }

  /* Rebuilding body.innerHTML replaces every <img>, so the thumbnails blink on
     something as small as a quantity step. When the lines themselves have not
     changed, patch the numbers into the existing DOM and leave the images be.
     The signature is what a rebuild would actually change: which lines exist,
     in what order, plus the spinner and error states. */
  /* What a line shows, rather than its server key: a provisional line and the
     confirmed line that replaces it are the same product and colour, so the
     signature does not change and the list is patched instead of rebuilt.
     Rebuilding would swap the <img> for a new element and the photo would
     visibly reload a second time. */
  // The bundle a line was added as part of (its hidden _bundle property), if any.
  function bundleOf(item) {
    return (item && item.properties && item.properties._bundle) || '';
  }

  function identityOf(item) {
    // A bundle's lines share one identity: they are drawn as a single row.
    if (bundleOf(item)) return 'bundle|' + bundleOf(item) + '|' + planKeyFor(item);
    return planKeyFor(item) + '|' +
      (isCartridge(item) ? 'cartridge' : colorKeyFor(item)) + '|' +
      displayTitle(item) + '|' + (maxQtyFor(item) === 1 ? 'L' : '');
  }

  /* Shopify hands back the cart newest first; the bag should read in the
     order things were added. A line gets a sequence the first time it is seen,
     assigned oldest first (the server list read backwards), and rows are drawn
     in that order from then on. A reload re-seeds the same way, so the order
     survives it, and a provisional line keeps its place when it is confirmed
     because both share an identity. */
  var seenOrder = {};
  var seenSeq = 0;
  /* Set only when the visitor bins a line, so the drawer closes for that and
     not for any other way the bag can end up empty. A failed add rolls its
     provisional line back, which empties the bag too, and closing there would
     hide the "sold out" message the visitor needs to read. */
  var closeWhenEmptied = false;

  function orderedLines(cart) {
    for (var i = cart.length - 1; i >= 0; i--) {
      var id = identityOf(cart[i]);
      if (!(id in seenOrder)) seenOrder[id] = ++seenSeq;
    }
    return cart.slice().sort(function (a, b) {
      return seenOrder[identityOf(a)] - seenOrder[identityOf(b)];
    });
  }

  /* Rows as the drawer shows them: a bundle's lines fold into one row (one
     photo, one combined price, controls acting on both), every other line is
     its own row. Shopify still holds separate lines; checkout lists them. */
  function displayRows(cart) {
    var rows = [], groups = {};
    for (var i = 0; i < cart.length; i++) {
      var id = identityOf(cart[i]);
      if (!bundleOf(cart[i])) { rows.push({ id: id, lines: [cart[i]] }); continue; }
      if (!groups[id]) { groups[id] = { id: id, bundle: bundleOf(cart[i]), lines: [] }; rows.push(groups[id]); }
      groups[id].lines.push(cart[i]);
    }
    for (var r = 0; r < rows.length; r++) {
      if (rows[r].bundle) rows[r].lines.sort(function (a, b) { return colorKeyFor(a) < colorKeyFor(b) ? -1 : 1; });
    }
    return rows;
  }

  /* A bundle row's quantity (pairs), combined price, cap and pending state.
     Two different colours arrive as two lines of one; two of the same colour
     arrive as a single line of two, since Shopify merges identical lines. So
     pairs are counted from the total units, not from the number of lines. */
  function bundleDisplay(row) {
    var finalC = 0, originalC = 0, pending = false, units = 0;
    for (var i = 0; i < row.lines.length; i++) {
      var l = row.lines[i], q = displayQty(l);
      units += q;
      finalC += lineAt(l, 'final_line_price', q);
      originalC += lineAt(l, 'original_line_price', q);
      pending = pending || !!l._pending;
    }
    var pairs = Math.max(1, Math.round(units / 2));
    var max = 99, names = [];
    for (var j = 0; j < row.lines.length; j++) {
      var line = row.lines[j];
      // How many devices of this colour make up one pair: 1 or 2.
      var perPair = Math.max(1, Math.round(displayQty(line) / pairs));
      max = Math.min(max, Math.floor(maxQtyFor(line) / perPair));
      for (var n = 0; n < perPair; n++) names.push(line.variant_title || '');
    }
    return {
      qty: pairs,
      max: max,
      pending: pending,
      names: variantLabel(names.join(' + ')),
      priceHTML: money(finalC) + (originalC > finalC ? ' <span class="cart-item-price-was">' + money(originalC) + '</span>' : '')
    };
  }

  var BIN_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<polyline points="3 6 5 6 21 6"></polyline>' +
    '<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>' +
    '</svg>';

  function bundleHTML(row) {
    var d = bundleDisplay(row);
    /* Two colours show the pair photo; two of the same colour show that
       colour's own photo, since the pair photo would be wrong. */
    var mixed = row.lines.length > 1;
    var img = mixed ? (window.BrumeConfig || {}).duoImage : imageFor(row.lines[0]);
    return '<div class="cart-item cart-item--bundle' + (d.pending ? ' cart-item--pending' : '') + '" data-color="' + row.id + '">' +
        (img ? '<img class="cart-item-image" src="' + img + '" alt="' + (mixed ? 'brume filter in Silver and Pearl White' : 'brume filter in ' + (row.lines[0].variant_title || '')) + '" loading="lazy">' : '') +
        '<div class="cart-item-details">' +
          '<span class="cart-item-name">Two Devices &amp; Two Filters</span>' +
          '<span class="cart-item-color" style="text-transform:none">' + d.names + '</span>' +
          '<span class="cart-item-price">' + d.priceHTML + '</span>' +
          '<div class="cart-item-actions">' +
            '<div class="cart-item-qty">' +
              '<button class="cart-qty-btn cart-qty-minus" data-bundle="' + row.bundle + '" aria-label="Decrease quantity"' +
                (d.pending || d.qty <= 1 ? ' disabled' : '') + '>&minus;</button>' +
              '<span class="cart-qty-value">' + d.qty + '</span>' +
              '<button class="cart-qty-btn cart-qty-plus" data-bundle="' + row.bundle + '" aria-label="Increase quantity"' +
                (d.pending || d.qty >= d.max ? ' disabled' : '') + '>&plus;</button>' +
            '</div>' +
            '<button class="cart-item-remove" data-bundle="' + row.bundle + '" aria-label="Remove item"' +
              (d.pending ? ' disabled' : '') + '>' + BIN_SVG + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function patchBundle(el, row) {
    var d = bundleDisplay(row);
    el.classList.toggle('cart-item--pending', d.pending);
    var priceEl = el.querySelector('.cart-item-price');
    if (priceEl) priceEl.innerHTML = d.priceHTML;
    var colorEl = el.querySelector('.cart-item-color');
    if (colorEl) colorEl.textContent = d.names;
    var valueEl = el.querySelector('.cart-qty-value');
    if (valueEl) valueEl.textContent = d.qty;
    var minusEl = el.querySelector('.cart-qty-minus');
    if (minusEl) minusEl.disabled = d.pending || d.qty <= 1;
    var plusEl = el.querySelector('.cart-qty-plus');
    if (plusEl) plusEl.disabled = d.pending || d.qty >= d.max;
    var removeEl = el.querySelector('.cart-item-remove');
    if (removeEl) removeEl.disabled = d.pending;
  }

  function anyPending(cart) {
    for (var i = 0; i < cart.length; i++) if (cart[i]._pending) return true;
    return false;
  }

  function nodeFrom(html) {
    var t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }

  // Update one row in place: quantity, price, key and control states.
  function patchLine(el, item) {
    var pending = !!item._pending;
    // The key changes when a provisional line is confirmed; carry it over so
    // the buttons act on the real line from then on.
    el.dataset.color = item.key;
    el.classList.toggle('cart-item--pending', pending);
    var d = lineDisplay(item);
    var priceEl = el.querySelector('.cart-item-price');
    if (priceEl) priceEl.innerHTML = d.priceHTML;
    var valueEl = el.querySelector('.cart-qty-value');
    if (valueEl) valueEl.textContent = d.qty;
    var minusEl = el.querySelector('.cart-qty-minus');
    if (minusEl) { minusEl.disabled = pending || d.qty <= 1; minusEl.dataset.color = item.key; }
    var plusEl = el.querySelector('.cart-qty-plus');
    if (plusEl) { plusEl.disabled = pending || d.qty >= maxQtyFor(item); plusEl.dataset.color = item.key; }
    var removeEl = el.querySelector('.cart-item-remove');
    if (removeEl) { removeEl.disabled = pending; removeEl.dataset.color = item.key; }
  }

  /* A bundle row's +/-: both lines move together, in a single request after
     the taps settle (see Brume.Cart.updateQuantities for why not two). */
  var bundleTimers = {};

  function linesOfBundle(bundle) {
    var cart = Brume.Cart.getCart(), out = [];
    for (var i = 0; i < cart.length; i++) if (bundleOf(cart[i]) === bundle) out.push(cart[i]);
    return out;
  }

  function stepBundle(bundle, delta) {
    var lines = linesOfBundle(bundle);
    if (!lines.length) return;
    var d = bundleDisplay({ lines: lines });
    var next = d.qty + delta;
    if (next < 1 || next > d.max) return;
    // A same-colour pair is one line of two, so it steps in twos.
    for (var i = 0; i < lines.length; i++) {
      var perPair = Math.max(1, Math.round(displayQty(lines[i]) / d.qty));
      pendingQty[lines[i].key] = next * perPair;
    }
    renderCartItems();

    if (bundleTimers[bundle]) clearTimeout(bundleTimers[bundle]);
    bundleTimers[bundle] = window.setTimeout(function () {
      delete bundleTimers[bundle];
      var current = linesOfBundle(bundle), updates = {}, sent = {};
      for (var k = 0; k < current.length; k++) {
        var key = current[k].key;
        if (pendingQty[key] !== undefined) { updates[key] = pendingQty[key]; sent[key] = pendingQty[key]; }
      }
      if (!Object.keys(updates).length) return;
      Brume.Cart.updateQuantities(updates).then(function () {
        if (bundleTimers[bundle]) return;   // newer taps are waiting; they will settle it
        for (var key2 in sent) if (pendingQty[key2] === sent[key2]) delete pendingQty[key2];
        renderCartItems();
      });
    }, SYNC_DELAY);
  }

  // One step of the +/- buttons. Floor of 1: the bin button removes a line.
  function stepQty(key, delta) {
    var cart = Brume.Cart.getCart();
    var item = null;
    for (var i = 0; i < cart.length; i++) {
      if (cart[i].key === key) { item = cart[i]; break; }
    }
    if (!item) return;
    var next = displayQty(item) + delta;
    if (next < 1 || next > maxQtyFor(item)) return;
    pendingQty[key] = next;
    renderCartItems();
    queueSync(key);
  }

  // ── Render ──────────────────────────────────

  function spinnerHTML() {
    return '<div class="cart-loading" role="status" aria-label="Updating bag"><span class="cart-spinner"></span></div>';
  }


  function renderCartItems() {
    var cart = Brume.Cart.getCart();

    // Enforce quantity caps on every cart change rather than at each entry
    // point, so repeated "Add to bag" clicks (which increment the existing
    // line server-side) are corrected the same way the drawer's "+" is.
    // The correction triggers another cart change, but by then the line sits
    // at the cap, so this settles after one pass.
    if (!enforcingCaps) {
      for (var c = 0; c < cart.length; c++) {
        var cap = maxQtyFor(cart[c]);
        if (cart[c].quantity > cap) {
          enforcingCaps = true;
          Brume.Cart.updateQuantity(cart[c].key, cap).then(function() {
            enforcingCaps = false;
          }).catch(function() {
            enforcingCaps = false;
          });
          return;
        }
      }
    }

    if (cart.length === 0) {
      seenOrder = {};
      seenSeq = 0;
      /* Binned the last line: close, rather than leaving the visitor on a
         dead-end "Your bag is empty". That empty state still serves anyone
         who opens the bag with nothing in it. */
      if (closeWhenEmptied && drawer && drawer.classList.contains('is-open')) {
        closeWhenEmptied = false;
        closeDrawer();
        return;
      }
      closeWhenEmptied = false;
      // While the first item is being added, show a spinner instead of the
      // empty state so the instantly-opened drawer doesn't flash "empty".
      if (isLoading) {
        body.innerHTML = spinnerHTML();
        footer.classList.add('is-hidden');
        shippingNote.classList.add('is-hidden');
        return;
      }
      var shopUrl = (window.BrumeConfig && window.BrumeConfig.productUrl) ? window.BrumeConfig.productUrl : '/collections/all';
      body.innerHTML =
        '<div class="cart-empty">' +
          (lastError ? '<p class="cart-error" role="alert">' + lastError + '</p>' : '<p>Your bag is empty</p>') +
          '<a href="' + shopUrl + '" class="cart-empty-cta">Shop Now</a>' +
        '</div>';
      footer.classList.add('is-hidden');
      shippingNote.classList.add('is-hidden');
      return;
    }

    footer.classList.remove('is-hidden');
    shippingNote.classList.remove('is-hidden');

    cart = orderedLines(cart);

    /* Reconcile row by row instead of rewriting the list. Rewriting replaces
       every <img>, so adding a second colour made the first line's photo load
       again. Rows are matched on what they show (identityOf): a row that is
       already right keeps its DOM node, a genuinely new line is built, and a
       line that has gone is dropped. */
    var existing = {};
    var rows = body.querySelectorAll('.cart-item');
    for (var r = 0; r < rows.length; r++) existing[rows[r].dataset.identity] = rows[r];

    var frag = document.createDocumentFragment();
    if (isLoading && !anyPending(cart)) frag.appendChild(nodeFrom(spinnerHTML()));
    if (lastError) frag.appendChild(nodeFrom('<div class="cart-error" role="alert">' + lastError + '</div>'));

    var rowList = displayRows(cart);
    for (var i = 0; i < rowList.length; i++) {
      var row = rowList[i];
      var el = existing[row.id];
      if (el) {
        delete existing[row.id];      // reused: keep the node, patch the numbers
        if (row.bundle) patchBundle(el, row); else patchLine(el, row.lines[0]);
      } else {
        el = nodeFrom(row.bundle ? bundleHTML(row) : lineHTML(row.lines[0]));
        el.dataset.identity = row.id;
      }
      frag.appendChild(el);           // moves reused rows out of body
    }

    body.innerHTML = '';              // what is left here is a line that went
    body.appendChild(frag);

    totalAmount.textContent = money(totalCentsNow(cart));
  }

  // One cart row's markup. Built once per line; updates go through patchLine.
  function lineHTML(item) {
    var display = lineDisplay(item);
    var qty = display.qty;
    var imgUrl = imageFor(item);
    // A provisional line (still being added) keeps the same markup as a
    // confirmed one, with its controls disabled, so confirming it is a patch.
    var isPending = !!item._pending;
    var isLocked = maxQtyFor(item) === 1;
    return '<div class="cart-item' + (isPending ? ' cart-item--pending' : '') + '" data-color="' + item.key + '">' +
        (imgUrl ? '<img class="cart-item-image" src="' + imgUrl + '" alt="' + item.product_title + '" loading="lazy">' : '') +
        '<div class="cart-item-details">' +
          '<span class="cart-item-name">' + brumeName(displayTitle(item)) + '</span>' +
          '<span class="cart-item-color" style="text-transform:none">' + variantLabel(item.variant_title) + '</span>' +
          '<span class="cart-item-price">' + display.priceHTML + '</span>' +
          // A line locked to a single unit (the free subscription refill) gets
          // no quantity controls at all: stepping between 1 and 1 is noise.
          // The remove button is still there if they want it gone.
          '<div class="cart-item-actions' + (isLocked ? ' cart-item-actions--locked' : '') + '">' +
            (isLocked ? '' :
            '<div class="cart-item-qty">' +
              '<button class="cart-qty-btn cart-qty-minus" data-color="' + item.key + '" aria-label="Decrease quantity"' +
                (isPending || qty <= 1 ? ' disabled' : '') + '>&minus;</button>' +
              '<span class="cart-qty-value">' + qty + '</span>' +
              '<button class="cart-qty-btn cart-qty-plus" data-color="' + item.key + '" aria-label="Increase quantity"' +
                (isPending || qty >= maxQtyFor(item) ? ' disabled' : '') + '>&plus;</button>' +
            '</div>') +
            '<button class="cart-item-remove" data-color="' + item.key + '" aria-label="Remove item"' +
              (isPending ? ' disabled' : '') + '>' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<polyline points="3 6 5 6 21 6"></polyline>' +
                '<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>' +
              '</svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  // Toggle the loading state (spinner) and re-render.
  function setLoading(state) {
    isLoading = !!state;
    if (isLoading) lastError = null; // a fresh add clears any stale error
    renderCartItems();
  }

  // Show an inline error (e.g. sold out) and auto-clear it shortly after.
  function showError(msg) {
    lastError = msg;
    isLoading = false;
    renderCartItems();
    setTimeout(function() {
      if (lastError === msg) { lastError = null; renderCartItems(); }
    }, 4000);
  }

  // ── Event Handlers ──────────────────────────

  function handleBodyClick(e) {
    var minus = e.target.closest('.cart-qty-minus');
    var plus = e.target.closest('.cart-qty-plus');
    var remove = e.target.closest('.cart-item-remove');

    if (minus) {
      if (minus.dataset.bundle) stepBundle(minus.dataset.bundle, -1);
      else stepQty(minus.dataset.color, -1);
    }

    if (plus) {
      // stepQty clamps to the cap, so the limit holds even if the button
      // somehow renders enabled.
      if (plus.dataset.bundle) stepBundle(plus.dataset.bundle, 1);
      else stepQty(plus.dataset.color, 1);
    }

    if (remove) {
      closeWhenEmptied = true;   // this tap, and only this tap, may close the drawer
      if (remove.dataset.bundle) {
        var bundleKeys = linesOfBundle(remove.dataset.bundle).map(function (l) { return l.key; });
        if (bundleKeys.length) Brume.Cart.removeItems(bundleKeys);
      } else {
        Brume.Cart.removeItem(remove.dataset.color);
      }
    }
  }

  /* Checkout must never outrun the cart. An add can still be in flight when
     the drawer is already showing its optimistic line, and a +/- tap waits out
     a 300ms debounce before it is sent. Navigating inside either window drops
     the change: the drawer says 2, checkout charges for 1. So hold the
     navigation until the cart has settled, with a hard timeout so a dead
     network never traps anyone on the page. */
  var CHECKOUT_MAX_WAIT = 3000;

  function cartSettling() {
    if (isLoading) return true;
    if (anyPending(Brume.Cart.getCart())) return true;
    for (var k in pendingQty) if (pendingQty.hasOwnProperty(k)) return true;
    for (var t in pendingTimers) if (pendingTimers.hasOwnProperty(t)) return true;
    for (var b in bundleTimers) if (bundleTimers.hasOwnProperty(b)) return true;
    return false;
  }

  function handleCheckoutClick() {
    var btn = drawer.querySelector('.cart-drawer-checkout');
    var gone = false;
    function go() {
      if (gone) return;
      gone = true;
      window.location.href = '/checkout';
    }

    if (!cartSettling()) { go(); return; }

    /* The tap registered: dim the button so it reads as busy rather than
       broken, and block a second tap while we wait. */
    if (btn) {
      btn.style.opacity = '0.7';
      btn.style.pointerEvents = 'none';
    }

    var deadline = Date.now() + CHECKOUT_MAX_WAIT;
    (function wait() {
      if (!cartSettling() || Date.now() >= deadline) { go(); return; }
      window.setTimeout(wait, 80);
    })();
  }


  // ── Init ────────────────────────────────────

  function initCartDrawer() {
    createDrawerHTML();

    // Close handlers
    overlay.addEventListener('click', closeDrawer);
    drawer.querySelector('.cart-drawer-close').addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    // Item interaction handlers
    body.addEventListener('click', handleBodyClick);

    // Checkout button
    drawer.querySelector('.cart-drawer-checkout').addEventListener('click', handleCheckoutClick);

    // Auto-render on cart changes
    Brume.Cart.onCartChange(renderCartItems);

    // Initial render
    renderCartItems();
  }

  // ── Expose API ──────────────────────────────

  // Shared so the buy pages can ask "is this line already at its cap?" without
  // re-deriving the rule and letting the two definitions drift apart.
  window.Brume.maxQtyFor = maxQtyFor;
  window.Brume.initCartDrawer = initCartDrawer;
  window.Brume.openDrawer = openDrawer;
  window.Brume.closeDrawer = closeDrawer;
  window.Brume.setCartLoading = setLoading;
  window.Brume.showCartError = showError;

})();
